import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { useNineGridBox } from 'modules/competencies/lib/ninegridboxContext'

import Content from './Content'
import Field from './Field'

export interface LabelType {
  text: string
  tooltipText?: string
  optional?: boolean
}

interface Props {
  isXaxis: boolean
}

const Filters = ({ isXaxis }: Props) => {
  const { form, loading, selectableCompetencyIds } = useNineGridBox()
  const labelAbscissa = { text: i18n.t('competencies_v2.ninebox.form.x_axis_values') }
  const labelOrdinate = { text: i18n.t('competencies_v2.ninebox.form.y_axis_values') }
  const title = isXaxis ? labelAbscissa : labelOrdinate
  const selectedCompetenciesForAxis: number[] = form.get(
    isXaxis ? 'x_axis_ids' : 'y_axis_ids'
  ).value
  const disabled =
    selectableCompetencyIds.length === 0 || loading || form.get('access_ids').value.length === 0

  return (
    <>
      <Text.Normal size="200" color="grey800" weight="semibold">
        {title.text}
      </Text.Normal>
      <Box
        borderRadius={{
          all: 'abs008',
        }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        overflowY="scroll"
        padding="s12"
      >
        {selectedCompetenciesForAxis?.length > 0 && (
          <Box paddingBottom="s24" gap="s4">
            {selectedCompetenciesForAxis.map((competencyId) => (
              <Field key={competencyId} competencyId={competencyId} isXaxis={isXaxis} />
            ))}
          </Box>
        )}
        {disabled && (
          <Box alignItems="flexStart">
            <Button.Decorative disabled={disabled} type="secondary" iconName="add">
              {i18n.t('competencies_v2.ninebox.form.button')}
            </Button.Decorative>
          </Box>
        )}
        {!disabled && (
          <Popover type="list">
            <Popover.Trigger>
              <Box alignItems="flexStart">
                <Button.Decorative type="secondary" iconName="add">
                  {i18n.t('competencies_v2.ninebox.form.button')}
                </Button.Decorative>
              </Box>
            </Popover.Trigger>
            <Popover.Content side="top" align="center" width="s360">
              <Box paddingX="s32" paddingY="s24">
                <Content isXaxis={isXaxis} />
              </Box>
            </Popover.Content>
          </Popover>
        )}
      </Box>
    </>
  )
}

export default observer(Filters)
